import gql from "graphql-tag"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullUser from "../fragments/fullUserV4"
import fullTeamV4 from "../fragments/fullTeamV4"

const query = gql`
  mutation UpdateUser($user: UserInput!, $withTeams: Boolean!) {
    updateUser(user: $user) {
      ...fullUser
      teams @include(if: $withTeams) {
        results {
          ...fullTeam
        }
      }
    }
  }
  ${fullUser}
  ${fullTeamV4}
`

export const updateUserKey = getQueryNames(query)[0]

export default query
